<template>

    <div>
        <b-form-group id="igCity">
            <b-form-input id="city"
                          name="city"
                          placeholder="Město *"
                          v-model="dataInput"
                          :state.sync="validInput"
                          v-on:keyup="inputTextChange"
                          aria-describedby="cityFeedback"></b-form-input>
            <b-form-invalid-feedback id="cityFeedback">Musíte vyplnit město.</b-form-invalid-feedback>
        </b-form-group>
    </div>

</template>

<script>

    export default {
        name: 'cityFormInput',
        data: function () {
            return {
                localModel: this.model,
                localValid: this.valid
            }
        },
        props: {
            model: {
            },
            valid: {
            }
        },
        computed: {
            dataInput: {
                get: function () {
                    return this.model;
                },
                set: function (newValue) {
                    this.localModel = newValue
                }
            },
            validInput: {
                get: function () {
                    return this.valid;
                },
                set: function (newValue) {
                    this.localValid = newValue
                }
            }
        },
        mounted() {
        },
        methods: {
            inputTextChange() {
                this.$emit('update:model', this.localModel);
            }
        }
    }

</script>